import React, { useState } from 'react'
import { Subscribe } from "unstated";

import StateContainer from "../../state/StateContainer";
import stringHelper from "../../utils/helpers/stringHelper"

import "./SliderCheckbox.css"

function SliderCheckbox(props) {

  const [checked, setChecked] = useState(false);

  const checkboxBackgroundColor = checked ? props.unstated.state.menuColorSecondary : props.unstated.state.menuColor;

  return (
    <div className="checkbox-container">
    <div
      className={`slider ${checked ? "slider-checked" : ""}`}
      style={{
        backgroundColor: stringHelper.removeAplhaFromColor(checkboxBackgroundColor)
      }}
    >
      <input
        type="checkbox"
        onChange={() => {
          setChecked(!checked);
          props.unstated.setCurrentTag(props.filterName)
        }}
        className="checkbox"
      />
      <div
        className={`slider-thumb ${checked ? "thumb-checked" : ""}`}
      ></div>
    </div>
    {props.label ?
      <div className="checkbox-label">{props.label}</div>
      : null}
  </div>
       
  );
}

const SliderCheckboxWithUnstated = (props) => {
  return (
    <Subscribe to={[StateContainer]}>
      {unstated => <SliderCheckbox {...props} unstated={unstated} />}
    </Subscribe>
  )
}

export default SliderCheckboxWithUnstated;
